module.exports = "<div #sectorEditorNode>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-sector-editor/nv-sector-editor.component.html
// module id = ../../../../../src/app/components/nv-sector-editor/nv-sector-editor.component.html
// module chunks = 0